export default __webpack_public_path__ + "static/media/contact.f1697383.jpg";